import { format } from "date-fns";
import { cn } from "../../../shared/utils";

export function Event({
  event,
  currentlySelectedEventId,
  eventDuration,
  disabled,
  onEventClick,
}) {
  // console.log(event, "event", currentlySelectedEventId, event.id);
  const selected = currentlySelectedEventId === event.id;
  const { options } = event;

  const styles = options?.borderColor
    ? {
        borderColor: options?.borderColor,
      }
    : {};

  const Component = onEventClick ? "button" : "div";

  return (
    <Component
      onClick={() => onEventClick?.(event)} // Note this is not the button event. It is the calendar event.
      className={cn(
        "group flex h-full w-full flex-col overflow-y-auto rounded-[4px] px-[6px]  text-xs font-semibold  leading-5 gap-1",
        "bg-subtle hover:bg-emphasis text-emphasis ",
        "  bg-sky-50 rounded-[6px] border border-teal-400 hideScroll text-teal-600",
        `${selected ? "bg-muted border border-muted text-white" : ""}`
        // status: options?.status,
        // disabled,
        // selected,
        // borderColor,
      )}
      style={styles}
    >
      <div className="w-full overflow-hidden overflow-ellipsis whitespace-nowrap text-left leading-4 capitalize">
        {event?.consumer?.profile?.first_name}
      </div>
      {eventDuration > 5 && (
        <p className="text-subtle text-left text-[10px] leading-none">
          {format(new Date(event.start_time), "h:mm a")} -{" "}
          {format(new Date(event.end_time), "h:mm a")}
        </p>
      )}
    </Component>
  );
}
